export const adminAddresses = [
    '0x54DEd7088B5E303dDd63e15c95F502B4c0c61627',
    '0x1689B564814db5f1C7Abd74129771D282E2d652b', // Benoit
]

export const releaseAccess = true;

export const superAdminAddress = '0x54DEd7088B5E303dDd63e15c95F502B4c0c61627'